import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import { Types as AdminTypes, Creators as AdminActions } from '../ducks/Admin';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getAdmins({ payload }) {
  try {
    const { status, data } = yield call(api.get, '/admins', {
      params: payload,
    });
    if (status === 200) {
      yield put(AdminActions.getAdminsSuccess(data));
    } else {
      Sentry.captureMessage('getAdmins failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(AdminActions.getAdminsError('Error listing Administrators'));
  }
}

function* postAdmin({ payload }) {
  try {
    const { status } = yield call(api.post, '/admins', payload);
    if (status === 200) {
      yield put(AdminActions.postAdminSuccess());
    } else {
      Sentry.captureMessage('postAdmin failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(AdminActions.postAdminError('Error registering admin'));
  }
}

function* getAdminById({ payload }) {
  try {
    const { status, data } = yield call(api.get, `/admins/${payload}`);
    if (status === 200) {
      yield put(AdminActions.getAdminByIdSuccess(data));
    } else {
      Sentry.captureMessage('getAdminById failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(AdminActions.getAdminByIdError('Error listing Administrator'));
  }
}

function* putAdmin({ payload }) {
  const { adminId } = payload;
  try {
    const { status } = yield call(api.put, `/admins/${adminId}`, payload.data);
    if (status === 200) {
      yield put(AdminActions.putAdminSuccess());
    } else {
      Sentry.captureMessage('putAdmin failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(AdminActions.putAdminError('Error editing admin'));
  }
}

function* getAdminsWatcher() {
  yield takeLatest(AdminTypes.GET_ADMINS, getAdmins);
}

function* postAdminWatcher() {
  yield takeLatest(AdminTypes.POST_ADMIN, postAdmin);
}

function* getAdminByIdWatcher() {
  yield takeLatest(AdminTypes.GET_ADMIN_BY_ID, getAdminById);
}

function* putAdminWatcher() {
  yield takeLatest(AdminTypes.PUT_ADMIN, putAdmin);
}

export default function* rootSaga() {
  yield all([
    fork(getAdminsWatcher),
    fork(postAdminWatcher),
    fork(getAdminByIdWatcher),
    fork(putAdminWatcher),
  ]);
}
